/**
 * @generated SignedSource<<8746ba0e246a52c60fe27a41b8260ff0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type discountCodeEditButton_DiscountCodeFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "discountCodeEditButton_DiscountCodeFragment";
};
export type discountCodeEditButton_DiscountCodeFragment$key = {
  readonly " $data"?: discountCodeEditButton_DiscountCodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"discountCodeEditButton_DiscountCodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "discountCodeEditButton_DiscountCodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "DiscountCode",
  "abstractKey": null
};

(node as any).hash = "449cf5bb09d280458e700645dc998b25";

export default node;
